import { inject, InjectionToken } from '@angular/core';

import { VisitorIdentificationService } from './visitor-identification.service';

export const VISITOR_ID = new InjectionToken<Promise<string>>('Visitor ID', {
  providedIn: 'root',
  factory: () => {
    // Inject the resolver service
    const visitorIDService = inject(VisitorIdentificationService);

    // Return the promise of identifier resolution
    return visitorIDService.resolveVisitorID();
  },
});
